module.exports = __webpack_public_path__ + "img/folder.d0fa9355.svg";